export const ENVIRONMENT_ISSUE_OPTIONS = Object.freeze([
  ["insect_vectors", "Unusual Presence of Insect Vectors"],
  ["environmental_concern", "Environmental Concern"],
]);

export const INSECT_VECTOR_OPTIONS = Object.freeze([
  ["mosquito", "Mosquitoes"],
  ["tick", "Ticks"],
  ["flea", "Fleas"],
  ["other", "Other vector"],
]);

export const ENVIRONMENTAL_CONCERN_OPTIONS = Object.freeze([
  "Flooding",
  "Contaminated water",
  "Raw sewage",
  "Air quality concerns",
  "Plant or crop damage",
  "Other environmental concern",
]);

export const ENVIRONMENT_REPORTER_FEELING_OPTIONS = Object.freeze([
  ["good", "Healthy"],
  ["sick", "Sick"],
  ["prefer_not_say", "Would rather not say"],
]);

export function environmentObservationValues(state) {
  if (state.environmentIssueType === "insect_vectors" && state.insectVectorType) {
    const label = INSECT_VECTOR_OPTIONS.find(([value]) => value === state.insectVectorType)?.[1] || state.insectVectorType;
    return [`Insect vector: ${label}`];
  }
  if (state.environmentIssueType === "environmental_concern") return [...state.environmentConcerns];
  return [];
}

export function resetEnvironmentReportState(state) {
  Object.assign(state, {
    environmentIssueType: "",
    insectVectorType: "",
    environmentConcerns: [],
    environmentReporterFeeling: "",
  });
}

export function isEnvironmentObservedDateInRange(value, now = new Date()) {
  const observedDate = parseIsoDate(value);
  const currentDay = parseIsoDate(arizonaIsoDate(now));
  if (!observedDate || !currentDay) return false;
  const earliestDay = new Date(currentDay);
  earliestDay.setUTCDate(currentDay.getUTCDate() - 28);
  return observedDate >= earliestDay && observedDate <= currentDay;
}

function parseIsoDate(value) {
  const match = String(value || "").trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  const year = Number.parseInt(match[1], 10);
  const month = Number.parseInt(match[2], 10) - 1;
  const day = Number.parseInt(match[3], 10);
  const date = new Date(Date.UTC(year, month, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month || date.getUTCDate() !== day) return null;
  return date;
}
import { arizonaIsoDate } from "./arizona-date.js";
